<!-- Modal -->
<div class="modal fade" id="fullPageModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header bg-white">
                <h6 class="modal-title text-primary-color alt-font font-weight-600 text-normal px-5 py-2"
                    id="staticBackdropLabel">{{ title }}</h6>
                <button type="button" class="btn-close btn-close-fullpage" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body p-5 custom-scrollbar">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>